import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { ToastContainer } from 'react-toastify'

import * as actions from '../../actions'
import {
  ReimpresionComprobante0,
  ReimpresionComprobante1
} from './steps'
import { FORM_REIMPRESION_COMPROBANTE } from '../../../../config/forms'
import { INTERVALO_CORTO } from '../../../../config/settings'

const selector = formValueSelector(FORM_REIMPRESION_COMPROBANTE)

class ReimpresionComprobante extends Component {
  constructor (props) {
    super(props)
    this.nextStep = this.nextStep.bind(this)
    this.prevStep = this.prevStep.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  nextStep () {
    const {
      reimpresionStep,
      admitibleEnReimpresion,
      numero
    } = this.props

    if (reimpresionStep === 0) {
      admitibleEnReimpresion(numero)
    }
  }

  prevStep () {
    this.props.reimpresionPrevStep()
  }

  handleSubmit () {
    this.props.finalizarReimpresionComprobante()
    this.props.destroy()
  }

  render () {
    const {
      reimpresionStep
    } = this.props

    return (
      <div className='camiones-ingreso-completo-container'>
        <h2>Reimpresión de Comprobante</h2>
        {reimpresionStep === 0 && <ReimpresionComprobante0 onSubmit={this.nextStep} />}
        {reimpresionStep === 1 &&
          <ReimpresionComprobante1 onSubmit={this.handleSubmit} onPrev={this.prevStep} />}
        <ToastContainer autoClose={INTERVALO_CORTO} />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reimpresionStep: state.camionesIngreso.reimpresionStep,
    numero: selector(state, 'numero'),
    iCompletoCpa: state.camionesIngreso.iCompletoCpa
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(
  reduxForm({
    form: FORM_REIMPRESION_COMPROBANTE
  })(ReimpresionComprobante)
)
